// extracted by mini-css-extract-plugin
export var container = "styles-module__container___frYzw";
export var logo = "styles-module__logo___RFTqu";
export var proBadge = "styles-module__proBadge___FpgZA";